import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import { Desk } from "@/features/think-tank/Desk";
import { Intel } from "@/features/think-tank/Intel";
import { Opportunities } from "@/features/think-tank/Opportunities";
import { Pilots } from "@/features/think-tank/Pilots";
import { Rules } from "@/features/think-tank/Rules";
import { ThisWeek } from "@/features/think-tank/ThisWeek";
import { SUBTITLE, TABS, TITLE, type TabKey } from "@/features/think-tank/ttModel";

export const Route = createFileRoute("/_authed/think-tank/")({
  component: ThinkTank,
});

/**
 * The Think Tank in HQ (Randy and Jeff only; the server's admin gate answers 404 to everyone
 * else). It watches the dog world, listens to our people, and scores every next move by the
 * rules Randy and Jeff set. HQ is admin-only, so it has no voice entry point.
 */
function ThinkTank() {
  const [tab, setTab] = useState<TabKey>("week");
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-lg font-semibold">{TITLE}</h1>
        <p className="text-sm text-zinc-500">{SUBTITLE}</p>
      </div>
      <div role="tablist" className="flex flex-wrap gap-1 rounded-md border border-zinc-200 p-0.5 text-sm">
        {TABS.map(([key, label]) => (
          <button key={key} type="button" role="tab" aria-selected={tab === key} data-testid={`tt-tab-${key}`}
            onClick={() => setTab(key)}
            className={`rounded px-3 py-1 ${tab === key ? "bg-zinc-900 text-white" : "text-zinc-600 hover:bg-zinc-100"}`}>
            {label}
          </button>
        ))}
      </div>
      {tab === "week" ? <ThisWeek />
        : tab === "rules" ? <Rules />
        : tab === "intel" ? <Intel />
        : tab === "desk" ? <Desk />
        : tab === "pilots" ? <Pilots />
        : <Opportunities />}
    </div>
  );
}
